import Image from 'next/image';

export default function FeatureCarouselCard(props) {
    const { title, description, feature_image, colour } = props;

    /**
     * return null needed for Next.js image validation
     */
    if (!feature_image.data.length) return null;

    return (
        <div className={`oCard ${colour}`}>
            <div className={`cardWrapper`}>
                <figure className={`oCardImage`}>
                    <h3 className={`fntH3 aTitle _mobile fontRTL`}>{title}</h3>
                    <Image
                        src={feature_image.data[0]?.attributes?.url}
                        alt={``}
                        width={`190`}
                        height={`316`}
                        className={`aImage`}
                        aria-hidden="true"
                        layout="responsive"
                    />
                </figure>
                <div className={`oCardBody fontRTL`}>
                    <h3 className={`fntH3 aTitle`}>{title}</h3>
                    <p className={`aText`}>{description}</p>
                </div>
            </div>
        </div>
    );
}
